import { Web3ReactProvider } from "@web3-react/core";
import { BrowserRouter } from "react-router-dom";
import Router from "./routes/index";
import "./App.css";
import { getLibrary } from "./contract/getLibrary";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider, createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      "Mulish", "Inter", "BlinkMacSystemFont", "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", "sans-serif",
    ].join(','),
  },});


const App = () => {

  return (
    <BrowserRouter>
      <Web3ReactProvider getLibrary={getLibrary}>
      <ThemeProvider theme={theme}>
        <Router />
        </ThemeProvider>
        <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={true}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
className="toastCustomStyle"
/>
      </Web3ReactProvider>
    </BrowserRouter>
  );
};

export default App;
